<template>
  <div class="redirect-external">
    <a-result
      v-if="!error"
      :status="redirected ? 'success' : 'info'"
      :title="loading ? 'Fetching Configuration...' : (redirected ? $t('pageTitles.cmsRedirectionTitle') : $t('pageTitles.cmsRedirectionSubTitleRedirecting'))"
      :sub-title="redirected ? $t('pageTitles.cmsRedirectionSubTitle') : ''"
    >
      <template #icon>
        <a-icon :type="redirected ? 'check-circle' : 'loading'" :theme="redirected ? 'twoTone' : 'outlined'" :two-tone-color="redirected ? '#52c41a' : ''" />
      </template>
      <template #extra>
        <a-space v-if="!loading">
          <a-button type="primary" icon="export" :disabled="!cmsUrl" @click="handleRedirect">
            {{ $t('pageTitles.cmsRedirectionButton') }}
          </a-button>
          <a-button @click="$router.back()">
            {{ $t('common.back') }}
          </a-button>
        </a-space>
      </template>
    </a-result>

    <a-result
      v-else
      status="error"
      title="Configuration Error"
      :sub-title="error"
    >
      <template #extra>
        <a-space>
          <a-button type="primary" @click="fetchCmsUrl">
            Retry
          </a-button>
          <a-button @click="$router.back()">
            {{ $t('common.back') }}
          </a-button>
        </a-space>
      </template>
    </a-result>
  </div>
</template>

<script>
import { getBusinessMetaData } from '@/api/business'

export default {
  name: 'RedirectExternal',
  data() {
    return {
      redirected: false,
      loading: true,
      error: null,
      cmsUrl: null,
    }
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.init()
      },
      immediate: true,
    },
  },
  methods: {
    async init() {
      this.redirected = false
      await this.fetchCmsUrl()
      if (this.cmsUrl) {
        setTimeout(() => {
          this.handleRedirect()
          this.redirected = true
        }, 1200)
      }
    },
    async fetchCmsUrl() {
      this.loading = true
      this.error = null
      
      const businessId = this.$route.query.business_id
      if (!businessId) {
        this.error = 'Business ID not found in URL'
        this.loading = false
        return
      }

      try {
        const response = await getBusinessMetaData({ business_id: businessId })
        const meta = (response.data || []).find(
          item => item.meta_name === 'b2b2c_web' && item.meta_display === 'b2b2c_web',
        )
        
        if (meta && meta.meta_value) {
          try {
            const config = JSON.parse(meta.meta_value)
            if (Array.isArray(config)) {
              const channelId = this.$route.params.id
              const channelConfig = config.find(item => String(item.channel_id) === String(channelId))
              if (channelConfig) {
                this.cmsUrl = channelConfig.url
              } else {
                this.error = `CMS URL configuration not found for channel ID: ${channelId}`
              }
            } else {
              this.cmsUrl = meta.meta_value
            }
          } catch (e) {
            this.cmsUrl = meta.meta_value
          }
        } else {
          this.error = 'CMS URL configuration (b2b2c_web) not found'
        }
      } catch (err) {
        console.error('Failed to fetch CMS metadata:', err)
        this.error = 'Failed to fetch configuration from server'
      } finally {
        this.loading = false
      }
    },
    handleRedirect() {
      if (!this.cmsUrl) return

      const { query } = this.$route
      const token = this.$keycloak?.token || localStorage.getItem('vue-token')
      const userId = this.$keycloak?.tokenParsed?.sub
      
      const params = new URLSearchParams({
        ...query,
        user_id: userId,
        token: token,
      })

      const baseUrl = this.cmsUrl.replace(/\/$/, '')
      window.open(`${baseUrl}/cms/manage?${params.toString()}`, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.redirect-external {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: #fff;
  border-radius: 8px;
  margin: 20px;
}
</style>
